import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';

export default function ServicesSection() {
  const { t } = useTranslation();
  const [ref, isInView] = useInView({ threshold: 0.05 });

  const services = [
    { icon: 'ri-shut-down-line', title: t('services.service1'), desc: t('services.service1Desc'), iconBg: 'bg-sky-50', iconColor: 'text-sky-600' },
    { icon: 'ri-computer-line', title: t('services.service2'), desc: t('services.service2Desc'), iconBg: 'bg-cyan-50', iconColor: 'text-cyan-600' },
    { icon: 'ri-drop-line', title: t('services.service3'), desc: t('services.service3Desc'), iconBg: 'bg-teal-50', iconColor: 'text-teal-600' },
    { icon: 'ri-tv-line', title: t('services.service4'), desc: t('services.service4Desc'), iconBg: 'bg-sky-50', iconColor: 'text-sky-600' },
    { icon: 'ri-volume-mute-line', title: t('services.service5'), desc: t('services.service5Desc'), iconBg: 'bg-cyan-50', iconColor: 'text-cyan-600' },
    { icon: 'ri-cpu-line', title: t('services.service6'), desc: t('services.service6Desc'), iconBg: 'bg-teal-50', iconColor: 'text-teal-600' },
    { icon: 'ri-battery-charge-line', title: t('services.service7'), desc: t('services.service7Desc'), iconBg: 'bg-sky-50', iconColor: 'text-sky-600' },
    { icon: 'ri-hard-drive-2-line', title: t('services.service8'), desc: t('services.service8Desc'), iconBg: 'bg-violet-50', iconColor: 'text-violet-600' },
    { icon: 'ri-brush-line', title: t('services.service9'), desc: t('services.service9Desc'), iconBg: 'bg-teal-50', iconColor: 'text-teal-600' },
    { icon: 'ri-keyboard-line', title: t('services.service10'), desc: t('services.service10Desc'), iconBg: 'bg-sky-50', iconColor: 'text-sky-600' },
    { icon: 'ri-fire-line', title: t('services.service11'), desc: t('services.service11Desc'), iconBg: 'bg-cyan-50', iconColor: 'text-cyan-600' },
    { icon: 'ri-question-line', title: t('services.service12'), desc: t('services.service12Desc'), iconBg: 'bg-sky-500', iconColor: 'text-white', highlight: true },
  ];

  return (
    <section id="services" ref={ref} className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="mb-14"
        >
          <span className="inline-block text-sky-500 text-sm font-semibold tracking-widest uppercase mb-3">
            {t('services.label')}
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 max-w-2xl leading-tight">
            {t('services.title')}
          </h2>
          <div className="w-14 h-1 bg-sky-500 mt-5 rounded-full"></div>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.45, delay: index * 0.04 }}
              className="group"
            >
              <div
                className={`h-full rounded-2xl p-6 border transition-all duration-300 cursor-default ${
                  service.highlight
                    ? 'bg-sky-500 border-transparent shadow-xl shadow-sky-200'
                    : 'bg-white border-slate-100 shadow-sm hover:shadow-md hover:border-sky-100'
                }`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 ${service.highlight ? 'bg-white/20' : service.iconBg}`}>
                  <i className={`${service.icon} text-2xl ${service.highlight ? 'text-white' : service.iconColor}`}></i>
                </div>
                <h3 className={`font-semibold text-base mb-1.5 ${service.highlight ? 'text-white' : 'text-slate-800'}`}>
                  {service.title}
                </h3>
                {service.highlight ? (
                  <a
                    href="https://t.me/goodfix_service"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="inline-flex items-center gap-2 mt-2 px-4 py-2 rounded-xl bg-white text-sky-600 text-sm font-semibold hover:bg-sky-50 transition-all duration-200 cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-telegram-fill text-base"></i>
                    Написати в Telegram
                  </a>
                ) : (
                  <p className={`text-sm leading-relaxed ${service.highlight ? 'text-white/80' : 'text-slate-500'}`}>
                    {service.desc}
                  </p>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
